import axios from 'axios'

type RequestOptions = {
  timeout?: number
}

let loginData = localStorage.getItem('loginInfo_ninegrid_access')
if(!loginData) loginData = localStorage.getItem('loginInfo_ninegrid_adm')

let loginDataAdm = localStorage.getItem('loginInfo_ninegrid_adm')

// Função para obter o idioma atual
const getCurrentLanguage = () => {
  const language = localStorage.getItem('i18nextLng') || 'pt'
  return language.split('-')[0] // Retorna apenas a parte antes do hífen (pt-BR -> pt)
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000, // 15s timeout no cliente HTTP
  headers: {
    Authorization:
      loginData && typeof loginData === 'string'
        ? `Bearer ${JSON.parse(loginData).accessToken}`
        : '',
    'Accept-Language': getCurrentLanguage(),
  },
})

const apiAdm = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 15000, // 15s timeout no cliente HTTP
  headers: {
    Authorization:
      loginDataAdm && typeof loginDataAdm === 'string'
        ? `Bearer ${JSON.parse(loginDataAdm).accessToken}`
        : '',
    'Accept-Language': getCurrentLanguage(),
  },
})

// Interceptador para garantir que o idioma seja sempre atualizado dinamicamente
api.interceptors.request.use(
  (config) => {
    config.headers['Accept-Language'] = getCurrentLanguage()
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptador para apiAdm também
apiAdm.interceptors.request.use(
  (config) => {
    config.headers['Accept-Language'] = getCurrentLanguage()
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default api

const setBearerToken = async (token: string) => {
  api.defaults.headers.Authorization = `Bearer ${token}`
}

const setBearerTokenAdm = async (token: string) => {
  apiAdm.defaults.headers.Authorization = `Bearer ${token}`
}

// Helper para extrair mensagem de erro com segurança
const getErrorMessage = (error: any): string => {
  const responseData = error?.response?.data

  if (typeof responseData === 'string' && responseData.trim()) {
    return responseData
  }

  if (responseData?.message) {
    return String(responseData.message)
  }

  if (responseData?.error) {
    if (typeof responseData.error === 'string') {
      return responseData.error
    }
    try {
      return JSON.stringify(responseData.error)
    } catch {
      return 'Erro na requisição HTTP'
    }
  }

  if (responseData?.typemsg === 'error') {
    return 'Operação rejeitada pelo servidor'
  }

  // Se é um erro padrão de axios
  if (error?.message) {
    return error.message
  }
  // Fallback genérico
  return 'Erro na requisição HTTP'
}

const GET = (url: string | void) =>
  api
    .get(url || '')
    .then((res) => res.data)
    .then((res) => {
      return res
    })
    .catch((e) => {
      throw getErrorMessage(e)
    })

const GET_ADM = (url: string | void) =>
  apiAdm
    .get(url || '')
    .then((res) => res.data)
    .then((res) => {
      return res
    })
    .catch((e) => {
      throw getErrorMessage(e)
    })

const POST = (
  url: string | void,
  params: object | Array<any | void> | void,
  options?: RequestOptions
) =>
  api
    .post(url || '', params, {
      timeout: options?.timeout,
    })
    .then((res) => res.data)
    .then((res) => {
      return res
    })
    .catch((e) => {
      throw getErrorMessage(e)
    })

  const PATCH = (url: string | void, params: object | Array<any | void> | void) =>
    api
      .patch(url || '', params)
      .then((res) => res.data)
      .then((res) => {
        return res
      })
      .catch((e) => {
        throw getErrorMessage(e)
      })

const POST_ADM = (url: string | void, params: object | Array<any | void> | void) =>
  apiAdm
    .post(url || '', params)
    .then((res) => res.data)
    .then((res) => {
      return res
    })
    .catch((e) => {
      throw getErrorMessage(e)
    })

const PUT = (url: string | void, params: object | Array<any> | void) =>
  api
    .put(url || '', params)
    .then((res) => res.data)
    .then((res) => {
      return res
    })
    .catch((e) => {
      throw getErrorMessage(e)
    })

const PUT_ADM = (url: string | void, params: object | Array<any> | void) =>
  apiAdm
    .put(url || '', params)
    .then((res) => res.data)
    .then((res) => {
      return res
    })
    .catch((e) => {
      throw getErrorMessage(e)
    })

const DELETE = (url: string | void, params?: object | Array<any> | void) =>
  api
    .delete(url || '', {
      data: params
    })
    .then((res) => res.data)
    .then((res) => {
      return res
    })
    .catch((e) => {
      throw getErrorMessage(e)
    })

const DELETE_ADM = (url: string | void, p0: { etag: string; key: string; bucketname: string }) =>
  apiAdm
    .delete(url || '')
    .then((res) => res.data)
    .then((res) => {
      return res
    })
    .catch((e) => {
      throw getErrorMessage(e)
    })

export {GET, POST, PUT, DELETE, PATCH, GET_ADM, POST_ADM, PUT_ADM, DELETE_ADM, setBearerToken, setBearerTokenAdm}
